import { Flex, Paragraph } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { PreviewCvFileEntry } from "@/components/Files/preview/PreviewCvFileEntry";
import { Attachment } from "@/data/attachments";

export interface CvsListProps {
  cvs: Attachment[];
}

export const CvsList: FC<CvsListProps> = ({ cvs }) => {
  const { t } = useTranslation("session");

  return (
    <Flex flexDirection="column" gap="sm">
      {cvs.map(cv => (
        <PreviewCvFileEntry attachment={cv} key={cv.id} />
      ))}

      {!cvs.length && (
        <Flex>
          <Paragraph size="p-md" color="n700">
            {t("CONSULTANT_PROFILES.DETAIL.CV.NO_ITEMS")}
          </Paragraph>
        </Flex>
      )}
    </Flex>
  );
};
